import { Schema } from 'effect';
import { create } from 'zustand';
import { readStored, writeStored } from '~/utils/browserStorage';

const STORAGE_KEY = 'trm-admin.seen-release-notes';

const SeenNotes = Schema.Array(Schema.String);

export const withSeen = (seen: readonly string[], ids: readonly string[]) => [
  ...seen,
  ...ids.filter((id) => !seen.includes(id)),
];

export const useSeenNotesStore = create<{
  seen: readonly string[];
  markSeen: (ids: readonly string[]) => void;
}>()((set, get) => ({
  seen: readStored(STORAGE_KEY, SeenNotes, []),
  markSeen: (ids) => {
    const seen = withSeen(get().seen, ids);
    writeStored(STORAGE_KEY, SeenNotes, seen);
    set({ seen });
  },
}));
